export default "__VITE_ASSET__BqYEzpvm__"